/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 */

export type ModelsAppModelStoreType =
    (typeof ModelsAppModelStoreType)[keyof typeof ModelsAppModelStoreType];

export const ModelsAppModelStoreType = {
    GOOGLE: "GOOGLE",
    APPLE: "APPLE",
    RU_STORE: "RU_STORE",
} as const;
